import { Skeleton } from "@/components/ui/skeleton";

export default function ProfileSkeleton() {
  return (
    <div className="space-y-8">
      <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-6 min-w-0">
          <Skeleton className="h-16 w-16 shrink-0 rounded-xl" />
          <div className="space-y-1 min-w-0">
            <div className="flex items-center gap-3 flex-wrap">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-6 w-20 rounded-full" />
            </div>
            <Skeleton className="h-4 w-44" />
          </div>
        </div>
        <Skeleton className="h-9 w-36 shrink-0" />
      </header>

      <div className="flex flex-col sm:flex-row gap-0 py-5">
        <div className="flex-1 flex items-baseline gap-3 px-7 py-2">
          <Skeleton className="w-2 h-2 rounded-full shrink-0" />
          <div>
            <Skeleton className="h-4 w-28 mb-1" />
            <Skeleton className="h-7 w-36" />
          </div>
        </div>
        <div className="flex-1 flex items-baseline gap-3 px-7 py-2">
          <Skeleton className="w-2 h-2 rounded-full shrink-0" />
          <div>
            <Skeleton className="h-4 w-20 mb-1" />
            <Skeleton className="h-7 w-24" />
          </div>
        </div>
      </div>

      <Skeleton className="h-9 w-full max-w-md" />
    </div>
  );
}
